import { render, staticRenderFns } from "./SofortLogo.vue?vue&type=template&id=61709ea2&scoped=true&"
var script = {}
import style0 from "./SofortLogo.vue?vue&type=style&index=0&id=61709ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61709ea2",
  null
  
)

export default component.exports